import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { useLocalStorage } from 'usehooks-ts';

import { STATUS_PAGE_ID } from '@/constants';

const REFETCH_INTERVAL_MS = 20000;
const LAST_KNOWN_STATUS_STORAGE_KEY = 'lastKnownStatusPageStatus';

type StatusPageResponse = {
  description: string;
  indicator: string;
};

// The status page ajax call should be deprioritized compared to the whole application
const windowLoadPromise = new Promise((resolve) => {
  window.addEventListener('load', () => {
    resolve(true);
  });
});

const useStatusPage = (): UseQueryResult<StatusPageResponse | null> => {
  const [lastKnownStatus, setLastKnownStatus] = useLocalStorage<StatusPageResponse | null>(
    LAST_KNOWN_STATUS_STORAGE_KEY,
    null,
  );

  return useQuery({
    queryKey: ['system', 'status'],

    queryFn: async () => {
      await windowLoadPromise;
      const { data } = await axios.get(`https://${STATUS_PAGE_ID}.statuspage.io/api/v2/status.json`);
      const status = data.status || null;
      setLastKnownStatus(status);
      return status;
    },

    placeholderData: lastKnownStatus ?? undefined,
    refetchInterval: REFETCH_INTERVAL_MS,
  });
};

export default useStatusPage;
